import { render, staticRenderFns } from "./statistical-data.pug?vue&type=template&id=60847220&lang=pug&"
import script from "./statistical-data.ts?vue&type=script&lang=ts&"
export * from "./statistical-data.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-data.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports